<template>
    <div id="recado">
        <div class="header">
            <div style="display: flex; flex-direction: column; align-items: start; width: 70%;">
                <v-btn @click="$emit('close-item')" variant="text" color="inherit"><img
                        src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/642712b9-7c61-4e25-87b0-5b7aefc49d67.svg"
                        alt=""></v-btn>
                <p class="submenu-title">Recado da equipe</p>
            </div>


        </div>

        <div style="margin-top: 5%;">
            <v-card color="#F5F5F5" v-for="recado in recados" :key="recado.name"
                style="width: 80%; margin-bottom: 10%; color: #464646;" class="mx-auto" max-width="344"
                :title="recado.title" :subtitle="recado.time">
                <template v-slot:prepend>
                    <img src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/54dfa5a2-f06f-4a68-a025-2cb5b9e45642.svg"
                        alt="">
                </template>
                <v-card-text style="font-size: 12px; text-align: start;">{{ recado.content }}</v-card-text>
            </v-card>

        </div>
    </div>
</template>

<script setup>
import { defineEmits } from 'vue';

defineEmits(["close-item"])

const recados = [
    {
        name: "recado_1",
        time: '3h atrás',
        title: 'Recado 1',
        content: 'Lorem ipsut, conserem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.'
    },
    {
        name: "recado_2",
        title: 'Recado 2',
        time: '3h atrás',
        content: 'Lorem ipsut, conserem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.'
    },
    {
        name: "recado_3",
        time: '3h atrás',
        title: 'Recado 3',
        content: 'Lorem ipsut, conserem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.'
    },
    {
        name: "recado_4",
        time: '3h atrás',
        title: 'Recado 4',
        content: 'Lorem ipsum dolor sit amet, conserem ipsum dolor sit amet, conserem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.'
    },

]
</script>

<style scoped>
#recado {
    width: 100%;
    height: 90%;
    background: #fff;
    position: absolute;
    top: 0;
    z-index: 1;
    overflow-y: auto;
}

.header {
    height: 25%;
    background-color: #BC4AFF;
    display: flex;
}

.submenu-title {
    color: white;
    margin-top: 15%;
    font-size: 20px;
    text-align: start;
    margin-left: 10%;
}

.icon-wrapper {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #F6E7FF;
    border-radius: 50%;
    margin-right: 20px;
}
</style>